module.exports = __webpack_public_path__ + "img/avatar-blank-training.a3ab4064.png";